module.exports = "../../../../platform/assets/pageMainIcon/icon-zhuangtai-4-green.svg";